import React from "react";
import "./globals.css";
import { Navigate, Route, Routes } from "react-router-dom";
import { useCurrentUser, UserProvider } from "./context/UserContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import PublicRoute from "./components/auth/PublicRoute";
import {
  AdminMainLayout,
  StaffMainLayout,
} from "./components/navbar/MainLayout";


// Admin imports
import AdminDashboard from "./admin/dashboard/AdminDashboardPage";
import UsersPage from "./admin/users-page/UsersPage";

// Staff imports
import StaffDashboard from "./staff/dashboard/StaffDashboardPage";
import RoleBasedRoute from "./route/RoleBasedRoute";
import { Dialog } from "./components/ui/dialog";
// import UserProfileDialog from "./admin/users-page/user-profile/UserProfilePage";
// import UserProfilePge from "./admin/users-page/user-profile/UserProfilePage";
import ResetPasswordForm from "./components/auth/ResetPasswordForm";
import ProfilePage from "./staff/profile/ProfilePage";
import StatementPage from "./staff/payslip/PayslipPage";
import RegisterEmployeePage from "./admin/users-page/register-page/RegisterEmployeePage";
import OnboardPage from "./admin/onboard-page/OnboardPage";
import IndivStaffPage from "./admin/users-page/indiv-user-page/IndivStaffPage";
import ProcessPayPage from "./admin/pay/ProcessPayPage";
import PayItemsPage from "./admin/pay/pay-items/PayItemsPage";
import PayRecordsPage from "./admin/pay/PayRecordsPage";
import LoginForm from "./components/auth/LoginForm";
import ForgotPasswordForm from "./components/auth/ForgotPasswordForm";
import LandingPageWrapper from "./components/auth/LandingPageWrapper";
import LandingPage from "./components/auth/LandingPage";
import LeaveBalancePage from "./admin/leave-balance/LeaveBalancePage";
import { LeaveTypesProvider } from "./context/LeaveTypesContext";

function App() {
  return (
    <AuthProvider>
      <UserProvider>
        <LeaveTypesProvider>
          <Routes>
            {/* Public Routes */}
            <Route element={<PublicRoute />}>
              <Route path="/login" element={<LandingPage />} />
              <Route
                path="/reset-password"
                element={
                  <LandingPageWrapper>
                    <ResetPasswordForm />
                  </LandingPageWrapper>
                }
              />
            </Route>

            {/* Protected Routes */}
            <Route element={<ProtectedRoute />}>
              {/* Default Route */}
              <Route path="/" element={<DefaultRedirect />} />
              {/* Admin Routes */}
              <Route element={<RoleBasedRoute allowedRoles={["ADMIN"]} />}>
                <Route element={<AdminMainLayout />}>
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/admin/users" element={<UsersPage />} />
                  <Route path="/admin/users/:id" element={<IndivStaffPage />} />
                  <Route path="/admin/process-pay" element={<ProcessPayPage />} />
                  <Route path="/admin/pay-records" element={<PayRecordsPage />} />
                  <Route path="/admin/leave-balance" element={<LeaveBalancePage />} />

                  <Route
                    path="/admin/users/:userId/pay-items/:year/:month"
                    element={<PayItemsPage />}
                  />
                  <Route
                    path="/admin/register"
                    element={<RegisterEmployeePage />}
                  />
                  <Route path="/admin/onboard/:id" element={<OnboardPage />} />
                </Route>
              </Route>

              {/* Staff Routes */}
              <Route element={<RoleBasedRoute allowedRoles={["STAFF"]} />}>
                <Route element={<StaffMainLayout />}>
                  <Route path="/staff" element={<StaffDashboard />} />
                  <Route path="/staff/profile" element={<ProfilePage />} />
                  <Route path="/staff/payslips" element={<StatementPage />} />
                </Route>
              </Route>

              {/* Catch-all route */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </LeaveTypesProvider>
      </UserProvider>
    </AuthProvider>
  );
}

// Helper component to redirect based on user role
const DefaultRedirect = () => {
  const { currentUser } = useCurrentUser();
  console.log("currentUser", currentUser);
  console.log("default redirect...");
  return currentUser?.role === "ADMIN" ? (
    <Navigate to="/admin" replace />
  ) : (
    <Navigate to="/staff" replace />
  );
};

export default App;
